<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>供給再開作業割当画面</h1>

<form [formGroup]="sgke352arequestForm" (ngSubmit)="onClickSearch()">
    <div *ngIf="cmpnyAreaList && initialhyojiInfo && businessDate">
        <app-sgke350d-condition [cmpnyAreaList]="cmpnyAreaList" [cmpnyAreaInit]="cmpnyAreaInit"
            [initialhyojiInfo]="initialhyojiInfo" [businessDate]="businessDate" (onClickSearchEvent)="onClickSearch()"
            (onClickClearEvent)="onClickClear()"></app-sgke350d-condition>
    </div>
</form>

<div *ngIf="searchresultList.length > 0">
    <app-sgke350d-result [searchresultList]="searchresultList" [searchresultHyojiInfo]="searchresultHyojiInfo"
        (onClickRegistEvent)="onClickRegist($event)"></app-sgke350d-result>
</div>